// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "@atlaskit-internal_dynamic-table" + "." + "cfbb4736" + ".chunk.css";
};